import React, { useCallback, useEffect, useState } from 'react';
import * as yup from 'yup';
import { t } from '../../../../util';

import { useRegistrationValidator } from '../../util/useLocalRegistrationValidator';
import { StyledDateTimeInput } from './styles';

const validationSchema = yup
  .date()
  .notRequired()
  .typeError('This is not a valid date');

export const DateTimeRegistrationLine: React.FC<
  DateTimeRegistrationLineProps
> = ({
  name,
  label,
  value,
  timeZone = '',
  minDate,
  maxDate,
  disabled,
  onChange,
  dataCy,
}) => {
  const [localValue, setLocalValue] = useState<Date | undefined>(value);
  const { error, validate } = useRegistrationValidator(validationSchema);

  const handleChange = useCallback(
    (date?: Date) => {
      const validationState = validate(date);
      setLocalValue(date);

      if (!date) {
        onChange(undefined);
      } else if (validationState.isValid) {
        onChange(date);
      }
    },
    [onChange, validate],
  );

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  return (
    <StyledDateTimeInput
      name={name}
      value={localValue ? new Date(localValue) : undefined}
      error={error}
      label={label}
      onChange={handleChange}
      timeZone={timeZone}
      calendarAlignment="center"
      autoComplete="off"
      disabled={disabled}
      minDate={minDate}
      maxDate={maxDate}
      dataCy={dataCy}
      t={t}
    />
  );
};

export interface DateTimeRegistrationLineProps {
  name: string;
  label: string;
  value?: Date;
  timeZone?: string;
  onChange: (value?: Date) => void;
  minDate?: Date;
  maxDate?: Date;
  disabled: boolean;
  dataCy?: string;
}
